import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  dialogContainer: {
    width: 510,
    maxWidth: '100%',
    borderRadius: 4,
    overflow: 'hidden',
  },

  content: {
    padding: '36px 32px',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'column',
  },

  titleSpace: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 32,
  },

  titleText: {
    textAlign: 'center',
    lineHeight: 1.2,
  },

  inputSpace: {
    width: '100%',
  },

  // Default state field
  textFieldDefault: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 4,
      '& fieldset': {
        borderColor: '#E0E0E0',
        borderWidth: '1px',
      },
      '&:hover fieldset': {
        borderColor: theme.palette.primary.main,
        borderWidth: '2px',
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.primary.main,
        borderWidth: '2px',
      },
    },
    '& .MuiInputBase-input': {
      padding: '20px 14px',
      fontSize: 16,
      color: '#0000008A',
    },
    '& .MuiInputLabel-outlined': {
      fontSize: 16,
      transform: 'translate(14px, 20px) scale(1)',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)',
    },
  },

  // Error state field
  textFieldError: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 4,
      '& fieldset': {
        borderColor: theme.palette.error.main,
        borderWidth: '1px',
      },
      '&:hover fieldset': {
        borderColor: theme.palette.error.main,
        borderWidth: '2px',
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.error.main,
        borderWidth: '2px',
      },
      '&.Mui-error fieldset': {
        borderColor: theme.palette.error.main,
      },
    },
    '& .MuiInputBase-input': {
      padding: '20px 14px',
      fontSize: 16,
      color: '#353535',
    },
    '& .MuiInputLabel-outlined': {
      fontSize: 16,
      color: theme.palette.error.main,
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      color: theme.palette.error.main,
    },
    '& .MuiFormHelperText-root': {
      fontSize: 12,
      color: theme.palette.error.main,
      marginTop: 5,
      marginLeft: 14,
    },
  },

  // Success state field
  textFieldSuccess: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 4,
      '& fieldset': {
        borderColor: '#E0E0E0',
        borderWidth: '1px',
      },
      '&:hover fieldset': {
        borderColor: theme.palette.primary.main,
        borderWidth: '2px',
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.primary.main,
        borderWidth: '2px',
      },
    },
    '& .MuiInputBase-input': {
      padding: '20px 14px',
      fontSize: 16,
      color: '#353535',
    },
    '& .MuiInputLabel-outlined': {
      fontSize: 16,
      color: '#353535',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)',
    },
  },

  buttonSpace: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: 40,
  },

  cancelButton: {
    fontWeight: 500,
    fontSize: 16,
    color: '#353535',
    textTransform: 'uppercase',
    padding: '8px 22px',
    borderRadius: 4,
    background: '#fff',
    boxShadow: 'none',
    '&:hover': {
      background: 'rgba(0,0,0,0.04)',
      boxShadow: 'none',
    },
  },
});

export default styles;
export const useStyles = makeStyles(styles);
